export const config = {
    USE_MOCK_DATA: true,
    TENNIS_HOST: process.env.REACT_APP_TENNIS_HOST,
}; 